<template>
  <div class="main-container">
    <div class="advanced-admin">
      <div class="advanced-admin__left">
        <main-menu></main-menu>
      </div>
      <div class="advanced-admin__right">

        <h2 class="main-title">Choose arena for edit</h2>

        <Loader v-if="isArenasLoadInProgress"></Loader>

        <div v-else class="advanced-admin__content">
          <div class="btns-row">
            <button class="ark-btn ark-btn--default"
                    v-if="selectedArenas.length > 0"
                    @click="unSelectAll()">Unselect all
            </button>
            <button class="ark-btn ark-btn--default"
                    v-else
                    @click="selectAll()">Select all
            </button>

            <div class="btns-row__right-btns">
              <button v-if="$checkRoles(['Administrator'])"
                      :disabled="selectedArenas.length === 0"
                      class="ark-btn ark-btn--danger"
                      @click="generateSitemap()">
                    <Loader v-if="isGenerateSiteMapInProgress"></Loader>
                    <span v-else>Generate sitemap</span>
              </button>

              <button v-if="$checkRoles(['Administrator'])"
                      :disabled="selectedArenas.length === 0"
                      class="ark-btn ark-btn--danger"
                      @click="tooglePopup('uploadPopup', true)">
                    <Loader v-if="isUploadFilesInProgress"></Loader>
                    <span v-else>Upload file(s)</span>
              </button>

              <UploadFilesPopup
                v-if="popups.uploadPopup"
                v-on:close="tooglePopup('uploadPopup', false)"
                :chosenArenas="selectedArenas">
              </UploadFilesPopup>
            </div>
          </div>

          <div class="advanced-admin__search">
            <FilterInput title="Filter arenas"
                         :filterList="arenas"
                         :filterByKey="arenaFilterFields"
                         v-on:filter="onFilterArenas"
            ></FilterInput>
          </div>

          <div class="arenas-table-container">
            <table class="arenas-table">
              <tr
                class="arenas-table__row"
                v-for="(arena) in filteredArenas"
                :key="arena.domain">
                <td class="arenas-table__cell">
                  <label class="form__checkbox-label">
                    <input type="checkbox"
                           :value="arena" v-model="selectedArenas">
                    {{arena.name}} - ({{arena.domain}})
                  </label>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <InfoModal
      v-if="isInfoModalVisible"
      :msg="infoModalMessage"
      :onCloseModal="closeInfoModal"
    ></InfoModal>
  </div>
</template>

<script>
  import Loader from '../../Loader/Loader.vue'
  import FilterInput from '../../FilterInput/FilterInput.vue'
  import UploadFilesPopup from '../UploadFilesPopup/UploadFilesPopup.vue'
  import InfoModal from '../../InfoModal/InfoModal.vue'
  import config from '../../../config'
  import {sortAsc} from '../../../utils/sorting'
  import MainMenu from '../../MainMenu/MainMenu.vue'

  export default {
    name: 'ArenasControlMain',
    components: {MainMenu, Loader, UploadFilesPopup, FilterInput, InfoModal},
    data () {
      return {
        arenas: [],
        arenaFilterFields: ['name', 'domain'],
        filteredArenas: [],
        selectedArenas: [],
        isArenasLoadInProgress: false,
        isGenerateSiteMapInProgress: false,
        isUploadFilesInProgress: false,
        popups: {
          uploadPopup: false
        },
        isUploadPopupVisible: false,
        isInfoModalVisible: false,
        infoModalMessage: ''
      }
    },
    created: function () {
      this.getAllArenas()
    },
    methods: {
      onFilterArenas: function (arenas) {
        this.filteredArenas = arenas
      },
      getAllArenas: function () {
        this.isArenasLoadInProgress = true
        const url = `${config.apiUrl}/arena/table-model/list`

        this.$http.get(url)
          .then(response => {
            this.arenas = sortAsc(response.body, 'name')
            this.arenas.forEach(arena => {
              arena.isSelected = false
            })
            this.filteredArenas = this.arenas
            this.isArenasLoadInProgress = false
          }, error => {
            console.log(error)
            this.isArenasLoadInProgress = false
          })
      },
      generateSitemap: function () {
        const url = `${config.apiUrl}/sitemap/create`
        const headers = {
          headers: {'Content-Type': 'application/json'}
        }

        this.isGenerateSiteMapInProgress = true

        let model = this.selectedArenas.map((arena) => {
          return arena.domain
        })

        this.$http.post(url, model, headers)
          .then(response => {
            this.isGenerateSiteMapInProgress = false
            this.showInfoModal('Sitemap generation complete.')
          }, error => {
            console.log(error)
            this.isGenerateSiteMapInProgress = false
          })
      },
      selectAll: function () {
        this.selectedArenas = [...this.arenas]
      },
      unSelectAll: function () {
        this.selectedArenas = []
      },
      tooglePopup: function (popup, isVisible) {
        this.popups[popup] = isVisible
      },
      closeInfoModal: function () {
        this.isInfoModalVisible = false
        this.infoModalMessage = ''
      },
      showInfoModal: function (message) {
        this.isInfoModalVisible = true
        this.infoModalMessage = message
      }
    }
  }
</script>

<style scoped src="./ArenasControlMain.scss" lang="scss"></style>
